import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ReviewList from './pages/ReviewList';
import ReviewDetail from './pages/ReviewDetail';
import CreateReview from './pages/CreateReview';

export default function App() {
  return (
    <div className="app">
      <Header />
      <main className="container">
        <Routes>
          <Route path="/react-projects/gamerfrog/" element={<Home />} />
          <Route path="/react-projects/gamerfrog/reviews" element={<ReviewList />} />
          <Route path="/react-projects/gamerfrog/new-review" element={<CreateReview />} />
          <Route path="/react-projects/gamerfrog/reviews/:id" element={<ReviewDetail />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
